/**
 * Value to recalculate the rating average.
 * @type {number}
 */export var RATING_SCALE_DIVISOR=20;